import React from 'react'
import styled from '@emotion/styled'
import { Col, Form, InputNumber, Row } from 'antd'

const StyledCreditsForm = styled.div({})

const CreditsForm = ({ form, formKeys }) => {
  const { getFieldDecorator } = form
  return (
    <StyledCreditsForm>
      <Form layout="vertical" hideRequiredMark>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item>
              {getFieldDecorator(formKeys.CREDITS, {
                rules: [{ type: 'number', required: true, min: 1, max: 500000, message: 'Please enter a positive amount of credits under 500,000' }]
              })(<InputNumber step={100} placeholder="ADD CREDITS" style={{width: '100%'}} />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </StyledCreditsForm>
  )
}

export default CreditsForm
